export default __webpack_public_path__ + "media/images/facebook-social-8dadc988eac80ffa2c01fcb7f26213d8.svg";